import { errors, serviceMchAccount } from '@/services';

export default {
	namespaced: true,
	state: {
		validMch: null,
	},
	mutations: {
		SET_VALIDMCH(state, info) {
			state.validMch = info;
		},
	},
	actions: {
		async getValidMch({ commit }) {
			try {
				const { ok, data } = await serviceMchAccount.getValidMch();
				if (!ok) {
					return;
				}
				commit('SET_VALIDMCH', data.data);
			} catch (err) {
				errors(err);
			}
		},
	},
};
